import styled from "styled-components";
import {AppBar, List, Toolbar} from "@mui/material";
import Logo from "../../assets/images/LogoWhite.svg";

export const TopBar = styled(AppBar)`
  display: flex;
  align-items: center;
  position: static;
  flex-direction: row;
  justify-content: space-between;
  &&{
    background-color: #1F299C;
  }
`;
export const Options = styled(Toolbar)`
  display: flex;
  width: 1200px;
  flex-direction: row;
  height: 68px;
  padding: 17px 0px;
  padding-left: 0px !important;
  padding-right: 0px !important;
  gap: 16px;
  order: 1;
  z-index: 1;
  justify-content: space-between;
  margin: 0 auto;
  &&{
    background-color: #1F299C;
  }
`;
export const IconProfile = styled.div`
  display: flex;
`;

export const ImagemLogo = styled.div`
  width: 120px;
  height: 38px;
  flex: none;
  display: flex;
  background-image: url(${Logo});
  order: 0;
  z-index: 2;
`;

export const ListOption = styled(List)`
  display: flex;
  flex-direction: row;
`;

